import {PRODUCTION_BUILD, SYSTEM_NAME, LOCAL_BACKEND, DEVAPI_BUILD, LOCAL_AUTH, DEV_BUILD_USE_HTTPS, PROD_BUILD_USE_HTTPS} from './app.settings';
import {
    SYSTEM_NAME_ALFRED,
    SYSTEM_NAME_EPC,
    SYSTEM_NAME_ETD,
    SYSTEM_NAME_ISBN,
    SYSTEM_NAME_LIBADMIN,
    SYSTEM_NAME_ROOMBOOK,
    SYSTEM_NAME_ZP,
    SYSTEM_NAME_UIK,
    SYSTEM_NAME_HELPDESK,
    SYSTEM_NAME_TOOLS, SYSTEM_NAME_AUTH
} from './constants';

import * as _ from 'lodash';
import { StringUtils } from './utils/string-utils';

function getApiProtocol(): string {
    if (PRODUCTION_BUILD) {
        if (PROD_BUILD_USE_HTTPS) {
            return 'https';
        } else {
            return 'http';
        }
    }

    if (DEVAPI_BUILD) {
        if (DEV_BUILD_USE_HTTPS) {
            return 'https';
        } else {
            return 'http';
        }
    }

    return 'https';
}

export const LOCAL_APP_PORTS = {
    [SYSTEM_NAME_EPC]: 0,
    [SYSTEM_NAME_ETD]: 3003,
    [SYSTEM_NAME_ISBN]: 3003,
    [SYSTEM_NAME_ROOMBOOK]: 3003,
    [SYSTEM_NAME_ZP]: 3003,
    [SYSTEM_NAME_UIK]: 3003,
    [SYSTEM_NAME_HELPDESK]: 3003,
    [SYSTEM_NAME_TOOLS]: 3003,
    [SYSTEM_NAME_LIBADMIN]: 3003,
    [SYSTEM_NAME_ALFRED]: 3003
};

function getClientProtocol(): string {
    if (PRODUCTION_BUILD) {
        if (PROD_BUILD_USE_HTTPS) {
            return 'https';
        } else {
            return 'http';
        }
    }

    if (DEVAPI_BUILD) {
        if (DEV_BUILD_USE_HTTPS) {
            return 'https';
        } else {
            return 'http';
        }
    }

    return 'http';
}

export const LOCAL_HOST = 'localhost';         // local frontend host (default localhost)
export const LOCAL_FRONTEND_PORT = '3003';     // local frontend port
export const LOCAL_BACKEND_PORT = '44390';     // local API port

export const PROD_HOST = 'portal.tuke.sk';         // production hostname
export const PROD_HOST_PORT = '';                      // production host port (empty for default)
export const PROD_API_HOST = 'portal.tuke.sk';        // production API hostname
export const PROD_API_HOST_PORT = '';                  // production API host port (empty for default)
export const DEV_HOST = 'portal.dev.msweb.tuke.sk';      // development hostname
export const DEV_HOST_PORT = '';                       // development host port (empty for default)
export const DEV_API_HOST = 'portal.dev.msweb.tuke.sk';     // development API hostname
export const DEV_API_HOST_PORT = '';                    // development API host port (empty for default)

export const AUTH_BASE_URL = getBaseApiUrl('AUTH');

// local addresses (used for local development)
export const LOCAL_FRONTEND_URL = `${getClientProtocol()}://${LOCAL_HOST}:${LOCAL_FRONTEND_PORT}`;
const LOCAL_API_URL = `${getApiProtocol()}://${LOCAL_HOST}:${LOCAL_BACKEND_PORT}/api`;

// base URL for frontend (non-local)
export const BASE_FRONTEND_URL = `${getClientProtocol()}://${PRODUCTION_BUILD ?
    (PROD_HOST + (StringUtils.isNullOrEmpty(PROD_HOST_PORT) ? '' : (':' + PROD_HOST_PORT))) :
    (DEV_HOST + (StringUtils.isNullOrEmpty(DEV_HOST_PORT) ? '' : (':' + DEV_HOST_PORT)))}`;

export function getBaseApiUrl(systemName?: string): string {
    if (PRODUCTION_BUILD) {
        return `${getApiProtocol()}://api.${systemName}.${PROD_API_HOST}${
            StringUtils.isNullOrEmpty(PROD_API_HOST_PORT) ? '' : (':' + PROD_API_HOST_PORT)
        }/api`;
    } else if (LOCAL_BACKEND && !DEVAPI_BUILD) {
        return LOCAL_API_URL;
    }

    return `${getApiProtocol()}://api.${systemName}.${DEV_API_HOST}${
        StringUtils.isNullOrEmpty(DEV_API_HOST_PORT) ? '' : (':' + DEV_API_HOST_PORT)
    }/api`;
}

export function getBaseFrontendUrl(systemName?: string): string {
    if (systemName === SYSTEM_NAME_AUTH) {
        return `${getClientProtocol()}://${PRODUCTION_BUILD ? PROD_HOST : DEV_HOST}${
            StringUtils.isNullOrEmpty(PRODUCTION_BUILD ? PROD_HOST_PORT : DEV_HOST_PORT) ? '' : (':' + (PRODUCTION_BUILD ? PROD_HOST_PORT : DEV_HOST_PORT))
        }`;
    }
    return `${getClientProtocol()}://${systemName}.${PRODUCTION_BUILD ? PROD_HOST : DEV_HOST}${
        StringUtils.isNullOrEmpty(PRODUCTION_BUILD ? PROD_HOST_PORT : DEV_HOST_PORT) ? '' : (':' + (PRODUCTION_BUILD ? PROD_HOST_PORT : DEV_HOST_PORT))
    }`;
}

// constructs base domain for cookie storage
export function getBaseCookieDomain(): string {
    if (PRODUCTION_BUILD) {
        return 'tuke.sk';
    } else if (DEVAPI_BUILD) {
        return 'tuke.sk';
    }

    return 'localhost';
}

// constructs URL for auth redirection
export function getAuthRedirectUrl(): string {
    if (LOCAL_AUTH) {
        return LOCAL_FRONTEND_URL + '/';
    }

    return BASE_FRONTEND_URL + '/';
}

// constructs base URL for API host without suffix
export function getCurrentApiHost(): string {
    if (PRODUCTION_BUILD) {
        return `${getApiProtocol()}://${PROD_API_HOST}`;
    } else if (LOCAL_BACKEND) {
        return `${getApiProtocol()}://${LOCAL_HOST}:${LOCAL_BACKEND_PORT}`;
    }

    return `${getApiProtocol()}://${DEV_API_HOST}`;
}

export const BASE_URL = getBaseApiUrl(SYSTEM_NAME);
export const CURRENT_API_HOST_URL = getCurrentApiHost();
export const AUTH_REDIRECT_URL = getAuthRedirectUrl();

export const BASE_COOKIE_DOMAIN = getBaseCookieDomain();

const ADMIN_URL = getBaseApiUrl(SYSTEM_NAME_LIBADMIN);
const ALFRED_URL = getBaseApiUrl(SYSTEM_NAME_ALFRED);

export const APP_URL_EPC = BASE_FRONTEND_URL + '/epc';
export const APP_URL_ETD = BASE_FRONTEND_URL + '/etd';
export const APP_URL_ISBN = BASE_FRONTEND_URL + '/isbn';
export const APP_URL_HELIOS = BASE_FRONTEND_URL + '/helios';
export const APP_URL_ROOMBOOK = BASE_FRONTEND_URL + '/roombook';
export const APP_URL_ZP = BASE_FRONTEND_URL + '/zp';
export const APP_URL_UIK = BASE_FRONTEND_URL + '/uik';
export const APP_URL_HELPDESK = BASE_FRONTEND_URL + '/helpdesk';
export const APP_URL_TOOLS = BASE_FRONTEND_URL + '/tools';
export const APP_URL_LIBADMIN = BASE_FRONTEND_URL + '/libadmin';

const API_FACULTY_CODEBOOK = '/codebook/faculties';
const API_DEPARTMENT_CODEBOOK = '/codebook/getDepartments/';

/* ### AUTH URLS ### */
const API_LOGIN = '/auth/token';
const API_LOGOUT = '/auth/logout';
const API_GET_EMPLOYMENTS = '/auth/getEmployments';
const API_CHANGE_EMPLOYMENT = '/auth/changeEmployment';
const API_CURRENT_USER = '/auth/getCurrentUser';

/* ### USER URLS ### */
const API_GET_USER_HISTORICAL = '/user/getWithHistorical/';
const API_GET_USER_PHOTO = '/user/photo/';
const API_GET_SEARCHED_USER = '/user/getSearched';
const API_UPDATE_EXTERNAL_USER = '/user/updateExternalThesisUser/';
const API_SEARCH_USER_COLLATE = '/user/searchCollate/';

/* ### ISBN URLS ### */
const API_ISBN = '/isbn';
const API_ISBN_UNUSED = API_ISBN+'/unused';
const API_ISBN_SETUNUSED = API_ISBN+'/setunused';

/* ### Publication URLS ### */
const API_PUBLICATION ='/publications'
const API_MY_PUBLICATION =API_PUBLICATION+ '/my';
const API_ACCEPT_PRINTS_PUBLICATION =API_PUBLICATION+ '/acceptPrints';
const API__PRINTS_CERTIFICATION_PUBLICATION =API_PUBLICATION+ '/printCertification';
const API_PUBLICATION_ASSIGN = API_PUBLICATION+'/assignIsbn';
const API_PUBLICATION_COUNT_NEW = API_PUBLICATION+'/count/new';

/* ### Author URLS ### */
const API_AUTHOR ='/authors'

/* ### Reports URLS ### */
const API_REPORTS ='/reports';
const API_REPORTS_ISBNCHANGEDREPORT =API_REPORTS+'/isbnChangedReport';
const API_REPORTS_ISBN =API_REPORTS+'/isbn';
const API_REPORTS_PRINTS =API_REPORTS+'/prints';
const API_REPORTS_ISBN_GENERATE = API_REPORTS_ISBN+'/generate';
const API_REPORTS_PRINTS_GENERATE = API_REPORTS_PRINTS+'/generate';
const API_REPORTS_ISBNCHANGEDREPORT_GENERATE =API_REPORTS_ISBNCHANGEDREPORT+'/generate';
const API_REPORTS_ISBN_COUNT = API_REPORTS_ISBN+ '/count';
const API_REPORTS_PRINTS_COUNT = API_REPORTS_PRINTS+ '/count';

/* ### CODEBOOK URLS ### */

const API_CODEBOOK = '/codebook';
const API_CODEBOOK_THEMATIC = API_CODEBOOK+'/thematicgrouptypes';
const API_CODEBOOK_BINDING = API_CODEBOOK+'/bindingtypes';
const API_CODEBOOK_DOCUMENT = API_CODEBOOK+'/get/all/Document';
const API_CODEBOOK_CATEGORY = API_CODEBOOK+'/categorytypes';
const API_CODEBOOK_LANGUAGE =API_CODEBOOK+'/languages';
const API_CODEBOOK_FACULTIES=API_CODEBOOK+'/faculties';
const API_CODEBOOK_ACTION=API_CODEBOOK+'/actionTypes';

/* ### History URLS ### */
const API_HISTORY = '/history';
const API_HISTORY_ACTIONS = API_HISTORY+'/actions';
const API_HISTORY_REPORTS = API_HISTORY+'/reports';

const API_STATISTIC = '/statistic';

export function getAppConfigurationUrl() {
    return `${BASE_URL}/config/client`;
}

export function getFacultyCodebookUrl() {
    return BASE_URL + API_FACULTY_CODEBOOK;
}

export function getDepartmentCodebookUrl(facultyId) {
    return BASE_URL + API_DEPARTMENT_CODEBOOK + '/' + facultyId;
}

export function getLoginUrl() {
    return `${BASE_URL}/auth/token`;
}

export function getLogoutUrl() {
    return `${BASE_URL}/auth/logout`;
}

export function getEmploymentsUrl() {
    return `${BASE_URL}/auth/getEmployments`;
}

export function changeEmploymentUrl() {
    return `${BASE_URL}/auth/changeEmployment`;
}

export function getHistoricalUserByIdUrl(id: number) {
    return BASE_URL + API_GET_USER_HISTORICAL + id;
}

export function getUserPhotoUrl(hash: string) {
    return BASE_URL + API_GET_USER_PHOTO + hash;
}

export function getApiIsbnUrl() {
    return BASE_URL + API_ISBN;
}

export function getBulkCreateIsbnsUrl() {
    return `${BASE_URL}/isbn/bulkCreate`;
}

export function getUnusedIsbnUrl() {
    return BASE_URL + API_ISBN_UNUSED;
}
export function getSetUnusedIsbnUrl() {
    return BASE_URL + API_ISBN_SETUNUSED;
}
export function getPublicationAssignUrl() {
    return BASE_URL + API_PUBLICATION_ASSIGN;
}
export function getPublicationByIdUrl(id: number) {
    return BASE_URL + API_PUBLICATION +'/'+ id;
}
export function getPublicationUrl() {
    return BASE_URL + API_PUBLICATION;
}
export function getMyPublicationUrl() {
    return BASE_URL + API_MY_PUBLICATION;
}
export function getAcceptPrintsPublicationUrl() {
    return BASE_URL + API_ACCEPT_PRINTS_PUBLICATION;
}
export function getPrintsCertificationPublicationUrl() {
    return BASE_URL + API__PRINTS_CERTIFICATION_PUBLICATION;
}
export function getAuthorUrl() {
    return BASE_URL + API_AUTHOR;
}
export function getCodebookLanguageUrl() {
    return BASE_URL + API_CODEBOOK_LANGUAGE;
}

export function getCodebookFacultiesUrl() {
    return BASE_URL + API_CODEBOOK_FACULTIES;
}

export function getSearchedUserUrl() {
    return BASE_URL + API_GET_SEARCHED_USER;
}

export function getUpdateExternalUserUrl(id) {
    return BASE_URL + API_UPDATE_EXTERNAL_USER + id;
}

export function getSearchUserCollateUrl(phrase) {
    return BASE_URL + API_SEARCH_USER_COLLATE + phrase;
}

export function getAllNotificationsForSystem(isForLoginScreen: boolean, systemName: string) {
    return `${ADMIN_URL}/notification?isForLoginScreen=${isForLoginScreen}&application=${systemName}`
}

export function getReportsIsbnCountUrl() {
    return BASE_URL+API_REPORTS_ISBN_COUNT;
}
export function getReportsIsbnUrl() {
    return BASE_URL+API_REPORTS_ISBN;
}
export function getReportsIsbnChangedReportUrl() {
    return BASE_URL+API_REPORTS_ISBNCHANGEDREPORT;
}
export function getReportsIsbnChangedReportGenerateUrl() {
    return BASE_URL+API_REPORTS_ISBNCHANGEDREPORT_GENERATE;
}

export function getReportsPrintsCountUrl() {
    return BASE_URL+API_REPORTS_PRINTS_COUNT;
}
export function getReportsPrintsUrl() {
    return BASE_URL+API_REPORTS_PRINTS;
}
export function getReportsPrintsGenerateUrl() {
    return BASE_URL+API_REPORTS_PRINTS_GENERATE;
}
export function getReportsIsbnGenerateUrl() {
    return BASE_URL+API_REPORTS_ISBN_GENERATE;
}
export function getPublicationCountNewUrl() {
    return BASE_URL+API_PUBLICATION_COUNT_NEW;
}
export function getCodebookBindingUrl() {
    return BASE_URL+API_CODEBOOK_BINDING;
}
export function getCodebookThematicUrl() {
    return BASE_URL+API_CODEBOOK_THEMATIC;
}
export function getCodebookDocumentUrl() {
    return BASE_URL+API_CODEBOOK_DOCUMENT;
}
export function getCodebookActionUrl() {
    return BASE_URL+API_CODEBOOK_ACTION;
}
export function getCodebookCategoryUrl() {
    return BASE_URL+API_CODEBOOK_CATEGORY;
}
export function getHistoryUrl() {
    return BASE_URL + API_HISTORY;
}
export function getActionsHistoryUrl() {
    return BASE_URL + API_HISTORY_ACTIONS;
}
export function getReportsHistoryUrl() {
    return BASE_URL + API_HISTORY_REPORTS;
}

export function getStatisticUrl() {
    return BASE_URL + API_STATISTIC;
}
export function getPublicFaqUrl() {
    return `${ADMIN_URL}/faq/getPublicFaqBySystem/isbn`
}

export function getDocumentCodebookUrl() {
    return BASE_URL + API_CODEBOOK_DOCUMENT;
}





// WEBPACK FOOTER //
// ./src/app/+app-custom/app.urls.ts